import React from "react";
import AccessibilityToolbar from "./AccessibilityToolbar";

export default function Layout({ children }) {
  return (
    <>
      {/* Skip link for keyboard users */}
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>

      <AccessibilityToolbar />

      <main id="main-content" tabIndex="-1">
        {children}
      </main>
    </>
  );
}